import { render, staticRenderFns } from "./DocumentDetailOptionsButton.vue?vue&type=template&id=32edfbcb&"
import script from "./DocumentDetailOptionsButton.vue?vue&type=script&lang=ts&"
export * from "./DocumentDetailOptionsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports